<script>
	const moudelcontrollRes = {
		title: '模块操作',
		rule: {
			"width": "800",
			"height": "600",
			"fApi": [],
			"rule": [{
					"type": "$input",
					"field": "name",
					"title": "操作名称",
					"value": "",
					"props": [],
					"validate": [{
						"required": false,
						"message": "必填项"
					}],
					"col": {
						"span": 22
					}
				},
				{
					"type": "$datePicker",
					"field": "create_time",
					"title": "创建时间",
					"value": "",
					"props": {
						"type": "datetime"
					},
					"validate": [{
						"required": false,
						"message": "必填项"
					}],
					"col": {
						"span": 22
					}
				},
				// {
				// 	"type": "select",
				// 	"field": "componenttype",
				// 	"title": "组件类型",
				// 	"value": "",
				// 	"options": [{
				// 			"value": 1,
				// 			"label": "系统预置"
				// 		},
				// 		{
				// 			"value": 2,
				// 			"label": "用户定义"
				// 		}
				// 	],
				// 	"props": {
				// 		"name": "componenttype"
				// 	},
				// 	"validate": [{
				// 		"required": false,
				// 		"message": "必填项"
				// 	}],
				// 	"col": {
				// 		"span": 22
				// 	}
				// },
				{
					"type": "el-row",
					"native": false,
					"children": [{
						"type": "el-button-group",
						"title": "批量操作",
						"field": "total",
						"children": [{
								"type": "el-button",
								"value": "1",
								"props": {
									"type": "primary",
									"size": "mini"
								},
								"children": [
									"显示"
								]
							},
							{
								"type": "el-button",
								"value": "2",
								"props": {
									"type": "primary",
									"size": "mini"
								},
								"children": [
									"隐藏"
								]
							}
						],
						"col": {
							"span": 24
						}
					}]
				},

				{
					"type": "el-row",
					"native": false,
					"children": [{
						"type": "el-col",
						"field": "field",
						"native": false,
						"children": [{
							"type": "radio",
							"title": "字段：",
							"field": "field_controll",
							"value": [],
							"options": [{
									"value": "1",
									"label": "显示",
									"disabled": false
								},
								{
									"value": "2",
									"label": "隐藏",
									"disabled": false
								}
							],
							"col": {
								"span": 20
							}
						}]
					}]
				}
			],
			"option": {
				"form": {
					"labelWidth": "120px",
					"hideRequiredAsterisk": false,
					"showMessage": false,
					"inlineMessage": false
				},
				"global": {
					"*": {
						"props": {
							"el": true,
							"size": "small",
							"disabled": false
						}
					}
				},
				"submitBtn": false,
				"resetBtn": false
			}
		}
	}
	import formBase from '@_system/components/base/form.vue'
	export default {
		name: 'controllForm',
		extends: formBase,
		props: {

		},
		data() {
			return {
				codeMap: {}
			}

		},

		watch: {

		},
		computed: {

		},
		created() {
			let totalcontroll = this.$store.state.system.toolbarButtonList.concat(this.$store.state.system
				.operateButtonList).concat(this.$store.state.toolbarButtons).concat(this.$store.state.operateButtons)
			let codeMap = {}
			totalcontroll.forEach((item) => {
				codeMap[item.code] = item.name ? item.name : item.content
			})
			this.codeMap = codeMap

		},
		mounted() {

		},
		methods: {
			init() {
				new Promise((resolve) => {
					if (this.beforeInit) {
						this.beforeInit(resolve)
					} else {
						resolve()
					}
				}).then(() => {
					let res = JSON.parse(JSON.stringify(moudelcontrollRes))
					this.rule = res.rule
					this.rule.rule.forEach((item) => {
						if (item.field == 'create_time' && this.controlltype == 1) {
							item.hidden = true
						}
						if (item.field == 'create_time' && this.extra.isprivate == 1) {
							item.hidden = true
						}
						if (item.field == 'name' && this.extra.isprivate == 1) {
							item.hidden = true
						}
					})
					
					
					if (this.extra.defaultvalue) {
						for (let i in this.extra.defaultvalue) {
							for (let j in this.rule.rule) {
								if (this.rule.rule[j].field == i) {
									this.rule.rule[j].value = this.extra.defaultvalue[i]
								}
							}
						}
					}
					this.title = res.title
					this.width = res.rule.width
					this.height = res.rule.height
					this.openwindow()

				})
			},
			regestEvent(rule, fApi) {
				let children = []

				let total_button = fApi.getRule('total').children
				total_button.forEach((item) => {
					item.on = {
						click: this.totalButton(item.value)
					}
				})


				children.push({
					type: 'el-col',
					props: {
						span: 24
					},
					children: [{
						"type": "el-divider",
						"children": ["数据"]
					}]
				})
				children.push({
					type: "el-row",
					native: false,
					children: [{
						type: "switch",
						title: "显示数据",
						field: "systemshowdata",
						value:true,
						children: [],
						col: {
							span: 24
						}
					}]
				})
					
					
				let field_controll = fApi.getRule('field_controll')
				if (this.extra.toolbarbutton.length != 0) {
					children.push({
						type: 'el-col',
						props: {
							span: 24
						},
						children: [{
							"type": "el-divider",
							"children": ["表头操作"]
						}]
					})
					this.extra.toolbarbutton.forEach((item) => {
						if (item) {
							let controll = JSON.parse(JSON.stringify(field_controll))
							controll.title = this.codeMap[item]
							controll.field = item + '_controll'
							controll.value = ''
							controll.title += '：'
							children.push(controll)
						}
					})
				}
				if (this.extra.operatebutton.length != 0) {
					children.push({
						type: 'el-col',
						props: {
							span: 24
						},
						children: [{
							"type": "el-divider",
							"children": ["行操作"]
						}]
					})
					this.extra.operatebutton.forEach((item) => {
						if (item) {
							let controll = JSON.parse(JSON.stringify(field_controll))
							controll.title = this.codeMap[item]
							controll.field = item + '_controll'
							controll.value = ''
							controll.title += '：'
							children.push(controll)
						}
					})
				}
				if (this.extra.listfield.length != 0) {
					children.push({
						type: 'el-col',
						props: {
							span: 24
						},
						children: [{
							"type": "el-divider",
							"children": ["列表字段"]
						}]
					})
					this.extra.listfield.forEach((item) => {
						if (item.visible !== false) {
							let controll = JSON.parse(JSON.stringify(field_controll))
							controll.title = item.title
							controll.field = item.field + 'listfield_controll'
							controll.value = ''
							controll.title += '：'
							children.push(controll)
						}
					})
				}
				fApi.updateRule('field', {
					children: children
				})
				fApi.updateRule('total', {
					children: total_button
				})
			},
			get() {
				return new Promise((reslove) => {
					this.$api[this.name].get(parseInt(this.id),{
							isprivate:this.extra.isprivate,
							staffid:this.extra.staffid,
						}).then((res) => {
							this.sourceData = res
							this.loading = false
							reslove()
						})
				})
			},
			setFormData() {
				if (this.sourceData) {
					this.beforeRender(this.sourceData)
					let res = this.sourceData
					let fields = this.fApi.fields()
					fields.forEach((item) => {
						if (item.match(/.*time$/g)) {
							res[item] = res[item] * 1000
						}
						if (item.indexOf("_controll") === -1) {
							this.fApi.setValue(item, res[item])
						}
					})
					for (let i in res.controll) {
						if (i == 'listfield') {
							for (let j in res.controll[i]) {
								if (res.controll[i][j]['props']['disabled']) {
									this.fApi.setValue(j + 'listfield_controll', '1')
								} else {
									this.fApi.setValue(j + 'listfield_controll', '2')
								}
							}
						}else if(i == 'systemshowdata'){
							this.fApi.setValue(i, res.controll[i])
						} else {
							if (!Array.isArray(res.controll[i])) {
								if (res.controll[i]['props']['disabled']) {
									this.fApi.setValue(i + '_controll', '1')
								} else {
									this.fApi.setValue(i + '_controll', '2')
								}
							} else {
								console.log(i, res.controll[i])
								this.fApi.setValue(i, res.controll[i])
							}
						}

					}
					this.afterGet(this.sourceData)
				}
			},
			totalButton(e) {
				return function() {

					let children = this.fApi.getRule('field').children
					children.forEach((item) => {
						if (item.field) {
							if (item.field.indexOf("_controll") != -1) {
								item.value = e
							}
						}
					})
					this.fApi.updateRule('field', {
						children: children
					})
				}.bind(this)
			},
			submit() {
				this.fApi.submit((formData) => {
					let obj = {}
					
					
					obj['listfield'] = {}
					this.extra.toolbarbutton.forEach((item) => {
						if (formData[item + '_controll']) {
							obj[item] = {
								props: {
									disabled: formData[item + '_controll'] === '1' ? true : false,
								},
								validate: []
							}
						}
					})
					this.extra.operatebutton.forEach((item) => {
						if (formData[item + '_controll']) {
							obj[item] = {
								props: {
									disabled: formData[item + '_controll'] === '1' ? true : false,
								},
								validate: []
							}
						}
					})

					this.extra.listfield.forEach((item) => {
						if (formData[item.field + 'listfield_controll']) {
							obj['listfield'][item.field] = {
								props: {
									disabled: formData[item.field + 'listfield_controll'] === '1' ?
										true : false,
								},
								validate: []
							}
						}
					})
					obj['systemshowdata'] = formData['systemshowdata']
					
					
					let data = {
						controll: JSON.stringify(obj),
						name: formData.name,
						create_time: formData.create_time / 1000,
						controlltype: formData.controlltype,
						componenttype: formData.componenttype,
						moduleid: this.foreingKey.moduleid,
						isprivate: this.extra.isprivate,
						staffid: this.extra.staffid
					}

					if (this.id == 0) {
						this.save(data)
					} else {
						this.update(data)
					}
				})
			},
		},
		components: {

		}
	}
</script>